import { Component, inject, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CIPXQuoteRequestIntakeForm } from '../../intake-form.types';
import { SharedModule } from '@sbd-account-portal/app/shared/shared.module';
import { SharedComponentsModule } from '@sbd-doug-frontend/shared/lib/shared-components/shared-components.module';
import { CIPXQuoteRequestIntakeFormService } from '../../intake-form.service';
import { CIPXQuoteRequestIntakeFormRequestDetailsScreenAndExplainComponent } from '../intake-form-request-details/sections/screen-and-explain/screen-and-explain.component';

@Component({
  standalone: true,
  imports: [SharedModule, SharedComponentsModule, CIPXQuoteRequestIntakeFormRequestDetailsScreenAndExplainComponent],
  selector: 'cipx-quote-request-intake-form-additional-questions',
  templateUrl: 'intake-form-additional-questions.component.html'
})

export class CIPXQuoteRequestIntakeFormAdditionalQuestionsComponent implements OnInit {
  private _intakeService = inject(CIPXQuoteRequestIntakeFormService);

  @Input() quoteRequestForm!: FormGroup<CIPXQuoteRequestIntakeForm>;


  ngOnInit() { }
}
